import React from 'react';
import { connect } from 'react-redux'

import "react-responsive-carousel/lib/styles/carousel.min.css";

import CardsGroupInfo from './cardsGroupInfo.js';
import CardsGroupsTitle from './cardsGroupsTitle'

class CardsGroupsSummary extends React.Component{

    render(){

        let categoryId = this.props.cardsGroupsFeatures[0].attributes.card_category_id
        let category = categoryId ? this.props.projectData.card_categories[categoryId.toString()] : null
        let renderedCardsGroups = []
        this.props.cardsGroupsFeatures.forEach(cardsGroup => {
            renderedCardsGroups.push(<CardsGroupInfo cardsGroupData={cardsGroup} />) 
        });

        return (
            <div>
                <div className="popup-menu-card-section card-color rounded-border mx-3 mb-3">
                    <CardsGroupsTitle category={category} />
                    <div className='cards-groups-table-container'>
                        <table class="table">
                            <tbody>
                                {renderedCardsGroups}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps( state ){
    return {
        projectData : state.projectData
    }
}

export default connect(mapStateToProps)(CardsGroupsSummary)